import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HostService } from './host.service';
import { ToastMessage } from '../toast-message/toast-message.service';

export interface VehicleSearchResult {
  rcId: string;
  userId: string;
  number: string;
  status: string;
  active: boolean;
  hostName?: string;
  mobile?: string;
}

@Component({
  selector: 'app-host-rc-results',
  template: require('./host-rc-results.component.html')
})
export class HostRcResultsComponent implements OnInit {
  vehicleNumber = '';
  isLoading = true;
  results: VehicleSearchResult[] = [];
  searchDone = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private hostService: HostService,
    private toast: ToastMessage
  ) {}

  ngOnInit() {
    this.vehicleNumber = this.route.snapshot.queryParamMap.get('number') || '';
    if (!this.vehicleNumber) {
      this.isLoading = false;
      this.searchDone = true;
      return;
    }
    this.hostService.searchByVehicleNumber(this.vehicleNumber).subscribe(
      (res: any) => {
        this.isLoading = false;
        this.searchDone = true;
        this.results = (res && Array.isArray(res.results)) ? res.results : [];
      },
      (err) => {
        this.isLoading = false;
        this.searchDone = true;
        this.toast.openSnackBarError(err && err.error && err.error.message || 'Failed to fetch RC records');
      }
    );
  }

  openHost(result: VehicleSearchResult) {
    this.router.navigate(['/host', result.userId], {
      queryParams: {
        name: result.hostName || '',
        mobile: result.mobile || '',
      }
    });
  }

  goBack() {
    this.router.navigate(['/hostSearch']);
  }

  statusClass(status: string): string {
    switch ((status || '').toLowerCase()) {
      case 'approved':   return 'status-chip status-approved';
      case 'rejected':   return 'status-chip status-rejected';
      default:           return 'status-chip status-processing';
    }
  }
}
